import { atom } from 'recoil';

export const UrlGenState = atom({
  key: 'url',
  default: '',
});
